
import { mapGetters } from "vuex";
import Card from "../Card.vue";
import moment from "moment";
export default {
  name: "Read History",
  components: {
    Card,
  },
  data() {
    return {
      isDrawerOpen: false,
      modal1: false,
      displayModal: false,
      moment,
    };
  },
  computed: {
    ...mapGetters(["getUserBooks", "getBookData"]),
    booksData() {
      return this.getUserBooks.books;
    },
    bookTitle: {
      get() {
        return this.getBookData.book.bookTitle;
      },
      set(value) {
        this.$store.commit("set", {
          type: "bookData",
          data: {
            ...this.getBookData,
            book: { ...this.getBookData.book, bookTitle: value },
          },
        });
      },
    },
    bookAuthor: {
      get() {
        return this.getBookData.book.bookAuthor;
      },
      set(value) {
        this.$store.commit("set", {
          type: "bookData",
          data: {
            ...this.getBookData,
            book: { ...this.getBookData.book, bookAuthor: value },
          },
        });
      },
    },
    bookGenre: {
      get() {
        return this.getBookData.book.bookGenre;
      },
      set(value) {
        this.$store.commit("set", {
          type: "bookData",
          data: {
            ...this.getBookData,
            book: { ...this.getBookData.book, bookGenre: value },
          },
        });
      },
    },
    bookPages: {
      get() {
        return this.getBookData.book.bookPages;
      },
      set(value) {
        this.$store.commit("set", {
          type: "bookData",
          data: {
            ...this.getBookData,
            book: { ...this.getBookData.book, bookPages: value },
          },
        });
      },
    },
  },
  methods: {
    async removeCurrentBook(x) {
      let res = await this.$store.dispatch("remove", {
        endpoint: `/books/${x}/`,
      });
      if (res.status == 201) {
      }
    },
    async editBooks(booksId) {
      let res = await this.$store.dispatch("get", {
        endpoint: `/books/${booksId}`,
        auth: true,
      });
      if (!!res) {
        this.$store.commit("set", {
          type: "bookData",
          data: res,
        });
      }
    },
    async updateBook() {
      let bookId = this.getBookData.book._id;
      let res = await this.$store.dispatch("put", {
        endpoint: `/books/${bookId}/`,
        auth: true,
        payload: this.getBookData.book,
      });
      if (res.status == 200) {
        this.$store.commit("set", {
          type: "userBook",
          data: res,
        });
      }
    },
  },
};
